var path = '/app/pages/projectManager/analytics/projectmanager.analytics.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;